import { useState } from 'react'
import { Navigate, Outlet } from 'react-router-dom'

const PrivateRoutes = () => {
    const [token,setToken] = useState(localStorage.getItem("AccessToken")||null)
    
    return (
        token ? <Outlet/> : <Navigate to='/'/>
    )
}
export default PrivateRoutes